// Banner wording. The official line belongs on an agency's own .gov or .mil
// site; the alternate line describes MDS everywhere else.
export const BANNER = {
  site: 'A design system for United States government websites',
  official: 'An official website of the United States government',
} as const
